/*
  Laser Blaze — desktop dropdowns open on hover.

  Dawn's header menus (<header-menu><details>) only open on click, and a
  second click closes them again, so on desktop the menu felt like it
  "didn't expand" or reacted unevenly. On devices with a real mouse we open
  the dropdown on hover and close it shortly after the pointer leaves.
  A click on an already hover-opened item keeps it open instead of closing
  it. Touch screens and keyboard navigation keep Dawn's click/Enter
  behaviour unchanged.
*/
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const CLOSE_DELAY = 180;

  const setOpen = (details, open) => {
    if (details.open === open) return;
    details.open = open;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
    if (!open) delete details.dataset.lbHoverOpen;
  };

  const init = () => {
    const menus = [...document.querySelectorAll('.header__inline-menu header-menu > details')];

    menus.forEach((details) => {
      const item = details.closest('li');
      const summary = details.querySelector('summary');
      if (!item || !summary) return;
      let closeTimer;

      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        menus.forEach((other) => other !== details && setOpen(other, false));
        if (!details.open) details.dataset.lbHoverOpen = 'true';
        setOpen(details, true);
      });

      item.addEventListener('mouseleave', () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
      });

      summary.addEventListener('click', (event) => {
        if (details.dataset.lbHoverOpen) {
          event.preventDefault();
          delete details.dataset.lbHoverOpen;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
